import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CourseCard } from "@/components/CourseCard";

export default function Courses() {
  const [courses, setCourses] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => { api.get("/courses").then((r) => setCourses(r.data)).catch(() => {}); }, []);
  const cats = ["All", ...Array.from(new Set(courses.map((c) => c.category)))];
  const shown = filter === "All" ? courses : courses.filter((c) => c.category === filter);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16" data-testid="courses-page">
      <p className="text-xs font-mono uppercase tracking-[0.2em] text-gold mb-2">Full catalog</p>
      <h1 className="font-display text-4xl lg:text-5xl font-extrabold text-white">Certification courses</h1>
      <p className="text-slate-300 mt-4 max-w-2xl">
        The presentation brochure and a set of sample questions are free for every course.
        The full bundle (course PDF + exam + certification) is available for a fee.
      </p>

      <div className="flex flex-wrap gap-2 mt-8">
        {cats.map((cat) => (
          <button key={cat} onClick={() => setFilter(cat)} data-testid={`filter-${cat}`}
            className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${filter === cat ? "bg-gold text-[#0B132B] border-gold" : "border-white/15 text-slate-300 hover:border-gold/50"}`}>
            {cat}
          </button>
        ))}
      </div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-10">
        {shown.map((c, i) => <CourseCard key={c.slug} c={c} index={i} />)}
      </div>
    </div>
  );
}
